import { render, staticRenderFns } from "./flights.vue?vue&type=template&id=0f0e71b5&scoped=true"
import script from "./flights.vue?vue&type=script&lang=js"
export * from "./flights.vue?vue&type=script&lang=js"
import style0 from "./flights.vue?vue&type=style&index=0&id=0f0e71b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0e71b5",
  null
  
)

export default component.exports